import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import path from 'path'

const children = [
  {
    name: 'dashboard',
    path: 'dashboard',
    component: () => import('../pages/admin/dashboard/Dashboard.vue'),
  },
  {
    name: 'venues',
    path: 'venues',
    component: () => import('@/pages/venues/VenuesPage.vue'),
  },
  {
    name: 'venue-create',
    path: 'venues/create',
    component: () => import('@/pages/venues/CreateVenuePage.vue'),
  },
  {
    name: 'venue-edit',
    path: 'venues/:id/manage',
    component: () => import('@/pages/venues/ManageVenuePage.vue'),
  },
  {
    name: 'users',
    path: 'users',
    component: () => import('@/pages/venues/VenueUsersPage.vue'),
  },
  {
    name: 'vendors',
    path: 'vendors',
    component: () => import('@/pages/vendors/VendorsPage.vue'),
  },
  {
    name: 'vendor-add',
    path: 'vendors/add',
    component: () => import('@/pages/vendors/AddVendorToVenuePage.vue'),
  },
  {
    name: 'create',
    path: 'vendors/create',
    component: () => import('@/pages/vendors/CreateVendorPage.vue'),
  },
  {
    name: 'vendor-edit',
    path: 'vendors/:id/edit',
    component: () => import('@/pages/vendors/EditVendorPage.vue'),
  },
  {
    name: 'profile',
    path: '/profile',
    component: () => import('@/pages/profile/Profile.vue'),
  }

  // add more children as needed
]

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: children,
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('@/pages/auth/Login.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

export default router
